var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 144,
    viewBox: "0 0 232 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 232,
    height: 144,
    fill: "url(#paint0_linear_274_1514)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84 52C84 47.625 87.5 44 92 44H100V60H84V52ZM140 60H104V44H140C144.375 44 148 47.625 148 52V92C148 96.5 144.375 100 140 100H92C87.5 100 84 96.5 84 92V64H100V92H140V60ZM135.75 70.875C135.5 71.625 134.75 72 134 72H132V78C132 81.375 129.25 84 126 84H120V86C120 86.875 119.5 87.625 118.75 87.875C118 88.25 117.125 88 116.5 87.5L112.5 83.5C111.75 82.75 111.75 81.375 112.5 80.625L116.5 76.625C117.125 76.125 118 75.875 118.75 76.25C119.5 76.5 120 77.25 120 78V80H126C127 80 128 79.125 128 78V72H126C125.125 72 124.375 71.625 124.125 70.875C123.75 70.125 124 69.25 124.5 68.625L128.5 64.625C129.25 63.875 130.625 63.875 131.375 64.625L135.375 68.625C135.875 69.25 136.125 70.125 135.75 70.875Z",
    fill: "url(#paint1_linear_274_1514)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_274_1514",
    x1: 116,
    y1: 0,
    x2: 116,
    y2: 144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4BBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_274_1514",
    x1: 116,
    y1: 40,
    x2: 116.278,
    y2: 162.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0989583,
    stopColor: "#6D5EDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#4B1E8D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/Content.01428a71b4ad5f675f72f98aa13fa4d6.svg";
export { ForwardRef as ReactComponent };